import { useState } from 'react';
import Button from '@mui/material/Button';
import CampaignModalForm from './CampaignModalForm';

interface CreateCampaignProps {
  styleOverrides?: React.CSSProperties;
  disabled: boolean;
  setUpdateCampaignFilter: Function;
}

export default function CreateCampaign(
  {
    styleOverrides,
    disabled,
    setUpdateCampaignFilter
  }: CreateCampaignProps
) {
  // show modal
  const [showCampaignModal, setShowCampaignModal] = useState(false);

  const handleModalClick = () => {
    // show modal to create campaign ID
    setShowCampaignModal(true);
  };

  return (
    <>
      <Button
        variant="contained"
        style={styleOverrides}
        disabled={disabled}
        onClick={handleModalClick}
      >
        Create Campaign ID
      </Button>
      {/* Modal for create campaign ID */}
      <CampaignModalForm
        showCampaignModal={showCampaignModal}
        setShowCampaignModal={setShowCampaignModal}
        setUpdateCampaignFilter={setUpdateCampaignFilter}
      />
    </>
  );
};
